<template>
  <!--
    微信斗图 tab 那种空心爱心。和 EmojiIcon 一样走 currentColor / 1em，
    套在 <i> 里是为了沿用 `.emoji-btn i { font-size }` 这套现成字号。
  -->
  <i class="wx-sticker-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 20.4s-6.6-4.15-9.05-8.05C1.05 9.5 2.1 6.15 5.15 5.35c1.8-.48 3.5.35 4.4 1.75L12 10.2l2.45-3.1c.9-1.4 2.6-2.23 4.4-1.75 3.05.8 4.1 4.15 2.2 7  -2.45 3.9-9.05 8.05-9.05 8.05z"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
    </svg>
  </i>
</template>

<script>
export default {
  name: 'StickerIcon'
}
</script>

<style scoped>
.wx-sticker-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;
}

.wx-sticker-icon > svg {
  display: block;
  width: 1em;
  height: 1em;
}
</style>
